import React, { Fragment, useEffect } from "react";
import {
  BlogPostInfo,
  CreateGenericPost,
  GenerateRandomPosts,
  GetBlogAuthors,
  GetBlogTagsOrCategories,
  GetPostInfoArrayFromResponse,
  GetPublicBlogPosts,
  GetPublicBlogPostsFromTagOrCat,
} from "../Utilities/BlogAPI";
import { NoRecordsBanner } from "../OopsBanner";
import { GetIsEditor } from "../Utilities/WindowUtils";
import { UserContext } from "../Definitions/UserContext";
import { Value } from "sass";
import ReactDOM from "react-dom";

export const missingImageUrl =
  "https://ab73d4f72ce8e9b15557-0c15488ef873a8828c5cc0dc7308f897.ssl.cf2.rackcdn.com/Websitebuilder/20241205214728.png"; // `https://ab73d4f72ce8e9b15557-0c15488ef873a8828c5cc0dc7308f897.ssl.cf2.rackcdn.com/Websitebuilder/20240826211811.png`

export const BlogURLStructure = {
  tags: "blog-search/tag/",
  category: "blog-search/category/",
  author: "blog-search/author/",
};

export const BlogSortType = {
  None: "",
  Newest: "newest",
  Oldest: "oldest",
  TitleAZ: "titleaz",
  TitleZA: "titleza",
  AuthorAZ: "authoraz",
  AuthorZA: "authorza",
};

export type BlogFilterData = {
  search: string;
  cat: string[];
  tag: string[];
  authors: string[];
  limit: number;
  sort: string;
};


export function GetBlogFilterDataFromString(data: string): BlogFilterData {
  let decoded = data;
  if (decoded.includes("%")) decoded = decodeURIComponent(data);


  if (decoded.length < 5) {
    return { search: "", cat: [], tag: [], authors: [], limit: 1000, sort: "" };
  }

  try {
    let obj = JSON.parse(decoded) as BlogFilterData;

    return {
      search: obj.search ?? "",
      cat: obj.cat ?? [],
      tag: obj.tag ?? [],
      limit: obj.limit ?? 1000,
      authors: obj.authors ?? [],
      sort: obj.sort ?? "",
    };
  } catch (e) {
    return { search: "", cat: [], tag: [], authors: [], limit: 1000, sort: "" };
  }
}

export default function RenderBlogList({
  context,
  layout,
  data,
  filter,
}: {
  context: UserContext;
  layout: string;
  data: any;
  filter: string;
}) {
  let layoutType = 0;
  let filterPage = false;
  switch (layout) {
    case "cards":
      layoutType = 1;
      break;
    case "large":
      layoutType = 2;
      break;
    case "condensed":
      layoutType = 3;
      break;
    case "filter":
      filterPage = true;
      layoutType = 0;
      break;
  }

  const [blogPosts, setBlogPosts] = React.useState<BlogPostInfo[]>([
    CreateGenericPost(),
    CreateGenericPost(),
    CreateGenericPost(),
  ]);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  // useEffect(()=>{
  //     if(!data?.isStenciled)
  //         setBlogPosts(GetPostInfoArrayFromResponse(data));

  // },[data])

  useEffect(() => {
    const onGetPostSuccess = (filt: any, data: any) => {
      setIsLoading(false);
      let posts = GetPostInfoArrayFromResponse(data);

      posts.map((post) => {
        if (post.publishDateStr)
          post.publishDateStr = post.publishDateStr.replace(
            /,\s\d{1,2}:\d{2}\s[AP]M$/,
            ""
          );
        return post;
      });
      if (filt.sort) {
        switch (filt.sort) {
          case BlogSortType.Newest:
            posts = posts.sort(
              (a, b) =>
                new Date(b.publishDateStr ?? "").getTime() -
                new Date(a.publishDateStr ?? "").getTime()
            );
            break;
          case BlogSortType.Oldest:
            posts = posts.sort(
              (a, b) =>
                new Date(a.publishDateStr ?? "").getTime() -
                new Date(b.publishDateStr ?? "").getTime()
            );
            break;
          case BlogSortType.TitleAZ:
            posts = posts.sort((a, b) => (a.title??"").localeCompare(b.title??""));
            break;
          case BlogSortType.TitleZA:
            posts = posts.sort((a, b) => (b.title??"").localeCompare(a.title??""));
            break;
          case BlogSortType.AuthorAZ:
            posts = posts.sort((a, b) => (a.author??"").localeCompare(b.author??""));
            break;
          case BlogSortType.AuthorZA:
            posts = posts.sort((a, b) => (b.author??"").localeCompare(a.author??""));
            break;
        }
      }

      if (filt.limit && filt.limit < 50) {
        posts = posts.slice(0, filt.limit);
      }
      setBlogPosts(posts);
    };

    const GetPostsWithFilters = (filt: any) => {
      GetPublicBlogPosts(
        context,
        (data) => {
          onGetPostSuccess(filt, data);
        },
        (data) => {
          console.error("Error loading blog posts");
          setBlogPosts([]);
          setIsLoading(false);
        },
        filterData.cat,
        filterData.tag,
        filterData.authors
      );
    };

    let filterData: any;
    if (layout == "filter") {
      filterData = {
        search: "",
        cat: [],
        tag: [],
        authors: [],
        limit: 100000,
        sort: "",
      };

      let location = window.location.pathname;
      let title = "";
      let denotation = "";
      let id =
        location
          .split("/")
          .filter((x) => x.length > 2)
          .pop() ?? "";
      let nameSplit = location.split("/blog-search/");
      if (nameSplit.length > 1) {
        title = decodeURI(nameSplit[1].split("/")[1] ?? "");
      }

      if (location.includes(BlogURLStructure.tags)) {
        GetPublicBlogPostsFromTagOrCat(
          true,
          context,
          title,
          (data) => {
            onGetPostSuccess(filterData, data);
          },
          (data) => {}
        );

        denotation = "TAGGED";
      } else if (location.includes(BlogURLStructure.category)) {
        GetPublicBlogPostsFromTagOrCat(
          false,
          context,
          title,
          (data) => {
            onGetPostSuccess(filterData, data);
          },
          (data) => {}
        );

        denotation = "CATEGORY";
      } else if (location.includes(BlogURLStructure.author)) {
        GetBlogAuthors(
          context,
          (data) => {
            if (data?.data?.data) {
              let find = data.data.data.find(
                (author: any) => author.encUserID == id
              );
              if (find) {
                filterData.authors = [find.encUserID];

          
                  let row = document.getElementById("blog-search-heading-row");
                  if (row) {
                    ReactDOM.render(
                      <>{find.photoURL ?
                        <img
                        className="v-animation-fade-in no-delay"
                        
                          src={find.photoURL}
                          style={{
                            background:"grey",
                            width: "64px",
                            height: "64px",
                            borderRadius: "50%",
                            objectFit: "cover",
                          }}
                        
                        />:
                        <div
                        className="v-animation-fade-in no-delay center-all"
                      
                          style={{
                            background:"#dddddd",
                            width: "64px",
                            height: "64px",
                            color:"#eee",
                            borderRadius: "50%",
                            border:"var(--default-font-color)",
                            fontSize:"20px"
                          }}
                        
                        >
                          {find.spintials??""}
                        </div>
                      
                      }
                        <h1 style={{textAlign:"left",alignContent:"center"}}>{`${find.firstName} ${find.lastName}`}</h1>
                      </>,
                      row
                    );
                  }
                
              }
            }

            GetPostsWithFilters(filterData);
          },
          (data) => {}
        );
      }

      if(denotation.length>0){
        let row = document.getElementById("blog-search-heading-row");
        if(row){
          ReactDOM.render(
            <div className="flex-column">
            {/* <div style={{opacity:".7",fontWeight:600,fontSize:"1.2em"}}><i>{denotation}</i></div> */}
              <h1  style={{textAlign:"left",alignContent:"center"}}>{title}</h1>
            </div>,
            row
          );
        }
      }
      // let hding = document.getElementById("blog-list-heading");
      // if (hding){ 
      //   hding.style.textAlign = "left";
      //   hding.textContent = title; 

      //   if(denotation){
      //     let tagDom = document.createElement("div");

      //   }

      // }

      return;
    } else filterData = GetBlogFilterDataFromString(filter);

    GetPostsWithFilters(filterData);
  }, [filter]);

  if (blogPosts.length == 0 && !isLoading) {
    return (
      <div className="w-full center-all flex-column gap-med  ">
        <NoRecordsBanner message="No Blog Posts Found" showInLive={true}>
          {GetIsEditor() && (
            <button
              className="w-button w-button-primary block-edit"
              style={{ marginTop: "1em", pointerEvents: "all" }}
              onClick={() => {
                (window as any).OpenToBlogSettings();
              }}
            >
              Create a New Post
            </button>
          )}
        </NoRecordsBanner>
      </div>
    );
  }

  return (
    <div
      className={
        "w-full flex-row flex-wrap align-stretch " + (isLoading && "stenciled")
      }
    >
      {layoutType == 0 &&
        blogPosts.map((post, index) => (
          <BlogPostLine key={index} post={post} />
        ))}
      {layoutType == 1 &&
        blogPosts.map((post, index) => (
          <BlogPostCard isLarge={false} key={index} post={post} />
        ))}
      {layoutType == 2 &&
        blogPosts.map((post, index) => (
          <BlogPostCard isLarge={true} key={index} post={post} />
        ))}
      {layoutType == 3 &&
        blogPosts.map((post, index) => (
          <BlogPostSearchResult key={index} post={post} />
        ))}
    </div>
  );
}

function BlogPostLine({ post }: { post: BlogPostInfo }) {
  let img = post.image.length > 1 ? post.image : missingImageUrl;
  return (
    <a
      href={"blog-post/" + post.slug}
      className="no-a flex-row w-full gap-large blog-card cursor-pointer"
      style={{
        margin: "8px 0",
        padding: "8px",
        background: "white",
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      <div
        className="blog-post-image no-shrink stencil-item"
        style={{
          width: "160px",
          height: "160px",
          backgroundImage: `url(${img})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          borderRadius: "8px",
        }}
      ></div>
      <BlogInfoColumn post={post} />
    </a>
  );
}

export function BlogPostSearchResult({
  post,
  fullWidth,
}: {
  post: BlogPostInfo;
  fullWidth?: boolean;
}) {
  let widthClas = fullWidth ? "w-full" : "w-half full-width-tablet";

  let img = post.image.length > 1 ? post.image : missingImageUrl;
  return (
    <div className={"flex-row " + widthClas} style={{ padding: "4px", overflow: "hidden", }}>
      <a
        href={"blog-post/" + post.slug}
        className={
          "no-a flex-row w-full h-full gap-large blog-card cursor-pointer"
        }
        style={{ background: "white", borderRadius: "8px", padding: "4px" }}
      >
        <div
          className="blog-post-image no-shrink stencil-item"
          style={{
            width: "64px",
            height: "64px",
            margin: "4px",
            backgroundImage: `url(${img})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            borderRadius: "8px",
            
          }}
        ></div>
        <div className="flex-column stencil-item">
          <span className="sub-inherit-color font-bold">
            {post.title}{" "}
            {post.readTime > 0 && (
              <span className="font-small" style={{ fontWeight: "normal" }}>
                <span className="read-time">
                {" "}
                - {post.readTime} min read </span>
              </span>
            )}
          </span>
          <span className="font-small">
            By {post.author} - {post.publishDateStr ?? ""}{" "}
          </span>
          <div
            className="flex-row gap-small font-small font-bold flex-wrap"
            style={{ opacity: ".75" }}
          >
            {post.category.map((tag, index) => (
              <Fragment key={index}>
                <BlogChip tag={tag} />
                {(index < post.category.length - 1 || post.tags.length > 0) && (
                  <InlineDot />
                )}
              </Fragment>
            ))}
            {post.tags.map((tag, index) => (
              <Fragment key={index}>
                <BlogChip tag={tag} />
                {index < post.tags.length - 1 && <InlineDot />}
              </Fragment>
            ))}
          </div>
        </div>
      </a>
    </div>
  );
}

function BlogPostCard({
  post,
  isLarge,
}: {
  post: BlogPostInfo;
  isLarge: boolean;
}) {
  let img = post.image.length > 1 ? post.image : missingImageUrl;

  let cls = isLarge ? "w-full" : "quarter-third-half-full";

  return (
    <div
      className={"flex-column " + cls}
      style={{ padding: isLarge ? "0 0 16px 0" : "8px", overflow: "hidden", }}
    >
      <a
        href={"blog-post/" + post.slug}
        className="no-a flex-column blog-card w-full h-full cursor-pointer"
        style={{ background: "white", borderRadius: "8px", padding: "8px" }}
      >
        <div
          className="blog-post-image w-full no-shrink stencil-item"
          style={{
            paddingBottom: "66%",
            backgroundImage: `url(${img})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            borderRadius: "8px",
          }}
        ></div>

        <div className="w-full" style={{ padding: "8px" }}>
          <BlogInfoColumn post={post} />
        </div>
      </a>
    </div>
  );
}

function BlogInfoColumn({ post }: { post: BlogPostInfo }) {
  return (
    <div className="flex-column gap-small stencil-item" style={{overflow:"hidden"}}>
      <h3 className="sub-inherit-color" style={{ fontSize: "1.25em" }}>
        {post.title}
      </h3>
      <p>
        <span className="blog-list-author" >{post.author && "By " + post.author }</span>{post.author&&<span className="blog-list-author blog-list-publish-date">{" - "}</span>} <i className="blog-list-publish-date">{ post.publishDateStr}</i>
      </p>
      {post.readTime > 0 && (
        <p className="read-time">{post.readTime} min read</p>
      )}

      <div
        className="flex-row gap-small font-small font-bold flex-wrap stencil-item"
        style={{ opacity: ".8" }}
      >
        {post.category.map((tag, index) => (
          <Fragment key={index}>
            <BlogChip tag={tag} isCat={true} />
            {(index < post.category.length - 1 || post.tags.length > 0) && (
              <InlineDot cls={"blog-cat"+(index==post.category.length-1?" blog-tag":"")} />
            )}
          </Fragment>
        ))}
        {post.tags.map((tag, index) => (
          <Fragment key={index}>
            <BlogChip tag={tag} />
            {index < post.tags.length - 1 && <InlineDot cls={"blog-tag "} />}
          </Fragment>
        ))}
      </div>
    </div>
  );
}

function BlogChip({ tag,isCat }: { tag: string; isCat?: boolean }) {

 
  return <span className={isCat?"blog-cat":"blog-tag"}>{tag}</span>;
}

function InlineDot({cls}: {cls?:string}) {
  return <span className={cls}>•</span>;
}

function GetDateStringFromVal(val: string) {
  return new Date(val ?? "").toLocaleDateString();
}
